import { MESSAGE_LIST, MESSAGE_ADDEDIT, MESSAGE_GETONE, UPLOAD_IMAGES, USERTYPE_WOP_LIST, MESSAGE_DELETE } from "../../api/constApi";
import { authHeader, fileAuthHeader } from "./authHeader";
import { apiInstance } from "./axiosApi";


export const UploadImagesApi = (payload) => {
    return apiInstance.post(UPLOAD_IMAGES, payload, {
        headers: fileAuthHeader(),
    });
};

export const MessageListApi = (payload) => {
    return apiInstance.post(MESSAGE_LIST, payload, {
        headers: authHeader(),
    });
};

export const AddEditMessageApi = (payload) => {
    return apiInstance.post(MESSAGE_ADDEDIT, payload, {
        headers: fileAuthHeader(),
    });
};

export const GetOneMessageApi = (payload) => {
    return apiInstance.post(MESSAGE_GETONE, payload, {
        headers: fileAuthHeader(),
    });
};

export const GetAllUserTypeApi = (payload) => {
    return apiInstance.get(USERTYPE_WOP_LIST, payload, {
        headers: authHeader(),
    });
};

export const DeleteMessageApi = (payload) => {
    return apiInstance.post(MESSAGE_DELETE, payload, {
        headers: authHeader()
    });
};